module.exports = __webpack_public_path__ + "static/gradient-eb0203387a51e44e17c90bc4ca11f8a6.png";